"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDateType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * PropType function that can be used with React components to validate objects
 * shaped like a "SimpleDate"
 *
 * type SimpleDate = {
 *   year: number;
 *   month: number;
 *   date: number;
 * };
 */
var SimpleDateType = _propTypes.default.shape({
  year: _propTypes.default.number.isRequired,
  month: _propTypes.default.number.isRequired,
  date: _propTypes.default.number.isRequired
});

exports.SimpleDateType = SimpleDateType;